<template>
    <card>
        <card-header>
            <card-overline>Alle Anfragen</card-overline>
        </card-header>
        <card-content>
            <table class="table table--stripped table--card">
                <thead>
                <tr>
                    <th>
                        PF-Nr
                    </th>
                    <th>
                        Kunde
                    </th>
                    <th class="text-right">
                        Stückzahl
                    </th>
                    <th class="text-right">
                        Liefertermin
                    </th>
                    <th class="text-center">
                        Zeichnung
                        <span><span>PDF | 3D</span></span>
                    </th>
                    <th class="text-right">
                        Anfragedatum
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="askForQuote in allAskForQuotesTable" :key="askForQuote.index">
                    <td>
                        <Link
                            :href="$$route('ask-for-quote', {'askForQuote': askForQuote.id} )">
                            {{ askForQuote.pfnumber }}
                        </Link>
                    </td>
                    <td>{{ askForQuote.client_user.company }}</td>
                    <td class="text-right" v-html="askForQuote.lot_qty"></td>
                    <td class="text-right">{{ askForQuote.delivery_date }}</td>
                    <td class="text-center">
                        <svg-vue icon="checkmark-square" class="icon" v-if="askForQuote?.sketch_files.length > 0" />
                        <svg-vue icon="checkmark-square-empty" class="icon" v-if="!askForQuote?.sketch_files.length > 0" />
                        <svg-vue icon="checkmark-square" class="icon" v-if="askForQuote?.cad_files.length > 0" />
                        <svg-vue icon="checkmark-square-empty" class="icon" v-if="!askForQuote?.cad_files.length > 0" />
                    </td>
                    <td class="text-right">{{ askForQuote.created_at }}</td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
export default {
    name: 'AllAskForQuotes',
    components: {CardContent, CardOverline, CardHeader, Card},
    props: {
        allAskForQuotes: Object,
    },
    computed: {
        allAskForQuotesTable() {

            let askForQuotes = Array;

            return Object.keys(this?.allAskForQuotes).map(key => {
                askForQuotes[key] = this.allAskForQuotes[key];
                askForQuotes[key].delivery_date = askForQuotes[key].delivery_date !== null ? this.$date(askForQuotes[key].delivery_date) : 'k.A.';
                askForQuotes[key].created_at = this.$date(askForQuotes[key].created_at);

                let lotQty = [];
                lotQty.push(askForQuotes[key].lotqty_1, askForQuotes[key].lotqty_2, askForQuotes[key].lotqty_3, askForQuotes[key].lotqty_4);
                askForQuotes[key].lot_qty = lotQty.filter(lot => lot !== null).join(', ');

                return askForQuotes[key];
            });
        },
    },
};
</script>
